<template>
  <div>
    <div>Tìm thấy <b class="text-danger">{{ count }}</b> cuộc gọi nghi ngờ vi phạm, <a href="javascript:;"
                                                                                       @click="show"><i>xem chi tiết</i></a>
    </div>
    <b-modal v-model="showDetailModel" size="xl" ok-only :title="$t('calls')">
      <div class="mb-2" v-if="data.client">
        <div><b>{{ $t('client') }}:</b> {{ data.client.companyName }}</div>
        <div><b>{{ $t('domain') }}:</b> {{ data.client.domain }}</div>
        <div v-if="!data.client.active"><b>{{ $t('status') }}:</b> <span class="badge badge-danger">{{
            $t('locked')
          }}</span></div>
      </div>

      <div class="c-smart-table tile" style="
    max-height: 500px;
    overflow-y: auto;
">
        <div class="row c-smart-table__title">
          <div class="col-lg-1"></div>
          <div class="col-lg-2">{{ $t('from') }}</div>
          <div class="col-lg-2">{{ $t('to') }}</div>
          <div class="col-lg-3">{{ $t('callDetail') }}</div>
          <div class="col-lg-4">{{ $t('hangupCause') }}</div>
        </div>
        <div class="row" v-for="item in data.calls" :key="item._id">
          <div class="col-lg-1">
            <div v-if="!item.call">{{ item.call }}</div>
            <div v-else>
              <div>
                <font-awesome-icon :class="iconClass(item.call)" size="2x" :icon="icon(item.call)"/>
                <br/>
                {{ $t(item.call.direction) }}
              </div>
            </div>
          </div>
          <div class="col-lg-2">
            <div v-if="!item.call">{{ $t('unknown') }}</div>
            <div v-else>
              <p><b class="c-smart-table__label">{{ $t('from') }}: </b></p>
              <p v-if="item.call.direction === 'inbound'">
                <b>{{ $t('number') }}:&nbsp;</b>
                <span>{{ item.call.fromNumber }}</span>
              </p>
              <p v-if="item.call.direction==='outbound'">
                <b>{{ $t('number') }}:&nbsp;</b>
                <router-link v-if="item.phoneNumber" target="_blank"
                             :to="`/number?keyword=${item.phoneNumber._id}`">{{ item.call.fromNumber }}
                </router-link>
                <span v-else>{{ item.call.fromNumber }}</span>

              </p>
              <div v-if="item.call.direction==='outbound' && item.phoneNumber && item.phoneNumber.errorMsg"
                   class="text-danger"><b>{{ $t('error') }}:</b> {{ item.phoneNumber.errorMsg }}
              </div>
              <div v-if="item.call.direction==='outbound' && item.phoneNumber">
                <label v-if="item.phoneNumber.inbound"
                       class="badge badge-success mr-1">{{ $t('inboundEnabled') }}</label>
                <label v-if="!item.phoneNumber.inbound"
                       class="badge badge-danger mr-1">{{ $t('inboundDisabled') }}</label>
                <label v-if="item.phoneNumber.outbound"
                       class="badge badge-success mr-1">{{ $t('outboundEnabled') }}</label>
                <label v-if="!item.phoneNumber.outbound"
                       class="badge badge-danger mr-1">{{ $t('outboundDisabled') }}</label>
                <label v-if="item.phoneNumber.isDemo" class="badge badge-info mr-1">{{ $t('isDemo') }}</label>
                <label v-if="item.phoneNumber.isPackage"
                       class="badge badge-primary mr-1">{{ $t(item.phoneNumber.packageType) }}
                  ({{ item.phoneNumber.packageExts ? item.phoneNumber.packageExts.length : 0 }}/{{ item.phoneNumber.packageLimit }})</label>
                <label v-if="item.phoneNumber.isRental" class="badge badge-info mr-1">{{ $t('isRental') }}</label>
                <label v-if="item.phoneNumber.isSpam" class="badge badge-danger mr-1">{{ $t('isSpam') }}</label>
                <label v-if="item.phoneNumber.privateFee" class="badge badge-info mr-1">{{ $t('privateFee') }}</label>
                <label v-if="item.phoneNumber.isCommit" class="badge badge-secondary mr-1">{{ $t('isCommit') }}</label>
              </div>
              <p v-if="item.call.direction === 'outbound' || item.call.direction === 'local'">
                <b>{{ $t('ext') }}:&nbsp;</b><span>{{ item.call.fromExt }}</span>
              </p>
            </div>
          </div>
          <div class="col-lg-2">
            <div v-if="!item.call">{{ $t('unknown') }}</div>
            <div v-else>
              <p><b class="c-smart-table__label">{{ $t('to') }}: </b></p>
              <p v-if="item.call.direction === 'inbound'">
                <b>{{ $t('number') }}:&nbsp;</b>
                <router-link v-if="item.phoneNumber" target="_blank"
                             :to="`/number?keyword=${item.phoneNumber._id}`">{{ item.call.toNumber }}
                </router-link>
                <span v-else>{{ item.call.toNumber }}</span>
              </p>
              <div v-if="item.call.direction==='inbound' && item.phoneNumber && item.phoneNumber.errorMsg"
                   class="text-danger"><b>{{ $t('error') }}:</b> {{ item.phoneNumber.errorMsg }}
              </div>
              <div v-if="item.call.direction==='inbound' && item.phoneNumber">
                <label v-if="item.phoneNumber.inbound"
                       class="badge badge-success mr-1">{{ $t('inboundEnabled') }}</label>
                <label v-if="!item.phoneNumber.inbound"
                       class="badge badge-danger mr-1">{{ $t('inboundDisabled') }}</label>
                <label v-if="item.phoneNumber.outbound"
                       class="badge badge-success mr-1">{{ $t('outboundEnabled') }}</label>
                <label v-if="!item.phoneNumber.outbound"
                       class="badge badge-danger mr-1">{{ $t('outboundDisabled') }}</label>
                <label v-if="item.phoneNumber.isDemo" class="badge badge-info mr-1">{{ $t('isDemo') }}</label>
                <label v-if="item.phoneNumber.isPackage"
                       class="badge badge-primary mr-1">{{ $t(item.phoneNumber.packageType) }}
                  ({{ item.phoneNumber.packageExts ? item.phoneNumber.packageExts.length : 0 }}/{{ item.phoneNumber.packageLimit }})</label>
                <label v-if="item.phoneNumber.isRental" class="badge badge-info mr-1">{{ $t('isRental') }}</label>
                <label v-if="item.phoneNumber.isSpam" class="badge badge-danger mr-1">{{ $t('isSpam') }}</label>
                <label v-if="item.phoneNumber.privateFee" class="badge badge-info mr-1">{{ $t('privateFee') }}</label>
                <label v-if="item.phoneNumber.isCommit" class="badge badge-secondary mr-1">{{ $t('isCommit') }}</label>
              </div>
              <p v-if="item.call.direction === 'outbound'">
                <b>{{ $t('number') }}:&nbsp;</b>
                <span>{{ item.call.toNumber }}</span>
              </p>
              <p v-if="item.call.direction ==='inbound' || item.call.direction === 'local'">
                <b>{{ $t('ext') }}:&nbsp;</b><span>{{ item.call.toExt }}</span>
              </p>
            </div>
          </div>
          <div class="col-lg-3">
            <div v-if="!item.call">{{ $t('unknown') }}</div>
            <div v-else>
              <p><b class="c-smart-table__label">{{ $t('callDetail') }}: </b></p>
              <p>
                <b>{{ $t('startTime') }}:&nbsp;</b><span>{{
                  item.call.startTime | moment('HH:mm:ss DD/MM/YYYY')
                }}</span>
              </p>
              <p v-if="item.call.answerTime">
                <b>{{ $t('answerTime') }}:&nbsp;</b><span>{{
                  item.call.answerTime | moment('HH:mm:ss DD/MM/YYYY')
                }}</span>
              </p>
              <p v-if="item.call.endTime">
                <b>{{ $t('endTime') }}:&nbsp;</b><span>{{ item.call.endTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
              </p>
            </div>
          </div>
          <div class="col-lg-4">
            <div v-if="!item.call">{{ $t('unknown') }}</div>
            <div v-else>
              <p>
                <b>{{ $t('duration') }}:&nbsp;</b><span>{{ item.call.duration | callDuration }}</span>&nbsp;|&nbsp;
                <b>{{ $t('billDuration') }}:&nbsp;</b><span>{{ item.call.billDuration | callDuration }}</span>&nbsp;|&nbsp;
                <span>({{ item.call.hangupCause }})</span>
                <template v-if="item.call.audioQuality">
                  &nbsp;|&nbsp;<b>{{ $t('audioQuality') }}:&nbsp;</b><span>{{ item.call.audioQuality }}</span>
                </template>
                <template
                    v-if="item.call.direction === 'inbound' && ( item.call.hangupCause !== 'NORMAL_CLEARING' || !item.call.billDuration)">
                  <span>
                    &nbsp;|&nbsp;<b class="text-danger">{{ $t('missCall') }}</b>
                  </span>
                </template>
              </p>
              <app-audio v-if="item.call.recordingDownloaded" :id="item.call._id" :duration="item.call.duration"/>
              <p v-if="item.transcripts && item.transcripts.length">
                <b>{{ $t('content') }}: </b>
                <span v-html="getContent(item)"></span>
              </p>
              <p v-else-if="item.call.billDuration" class="small">{{ $t('noTranscript') }}</p>
            </div>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary" @click="showDetailModel = false">{{ $t('close') }}</button>
        <button @click="del(data._id)" type="button"
                v-if="['owner','admin', 'tech', 'account', 'operationsManager', 'am'].includes($store.state.user.role)"
                class="btn btn-danger mr-1">
          <font-awesome-icon icon="window-close"/>&nbsp;{{ $t('skip') }}
        </button>
        <button @click="approved(data._id)" type="button"
                v-if="['owner', 'admin', 'account', 'accountant'].includes($store.state.user.role)"
                class="btn btn-warning mr-1">
          <font-awesome-icon icon="check"/>&nbsp;{{ $t('lock') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AppAudio from "../../components/AppAudio";

export default {
  name: "CallDetail",
  props: ["id", "count", 'model'],
  components: {AppAudio},
  data() {
    return {
      service: '/fault-detection-call',
      showDetailModel: false,
      data: []
    }
  },
  methods: {
    getContent(item) {
      let content = item.transcripts.join(", ");
      if (!content || !item.keyword) {
        return content;
      }
      content = content.toLowerCase();
      return content.replaceAll(item.keyword.toLowerCase(), `<span class='text-danger text-underline'><u>${item.keyword}</u></span>`);
    },
    approved: function (id) {
      this.$swal({
        title: this.$t('lockClient'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.$service.post(this.service + "/approved/" + id).then(response => {
            if (response.data) {
              this.$swal({
                title: this.$t('lockSuccess'),
                icon: 'success'
              });
              this.$bus.$emit("faultDetectionCall");
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                title: this.$t('error'),
                text: error.response.data.message,
                icon: 'error'
              });
            }
          })
        }
      })
    },
    del: function (id) {
      this.$swal({
        title: this.$t('deleteConfirm'),
        icon: "warning",
        showCancelButton: true
      }).then((result) => {
        if (result.isConfirmed) {
          let loader = this.$loading.show();
          this.$service.delete(this.service + '/' + id + '?ignore=' + result.value).then(response => {
            if (response.data) {
              this.showDetailModel = false;
              this.$bus.$emit("faultDetectionCall");
              this.$swal({
                title: this.$t('success'),
                text: this.$t('deleted'),
                icon: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('deleteFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    show() {
      if (this.id) {
        let loader = this.$loading.show();
        this.data = [];
        this.$service.get(`${this.service}/detail/${this.id}`).then(response => {
          if (response && response.data) {
            this.data = response.data;
          }
          this.showDetailModel = true;
          loader.hide();
        });
      }
    },
    icon(item) {
      if (item.direction === 'inbound') {
        return 'sign-in-alt';
      }
      if (item.direction === 'outbound') {
        return 'sign-out-alt';
      }
      if (item.direction === 'local') {
        return 'sync-alt';
      }
    },
    iconClass(item) {
      if (item.hangupCause === 'NORMAL_CLEARING') {
        return 'text-success';
      } else {
        return 'text-danger';
      }
    },
  },
  i18n: {
    messages: {
      en: {
        faultDetectionCall: "Cuộc gọi nghi vi phạm từ khoá",
        await: "Chờ kiểm tra",
        number: 'Number',
        ext: 'Extension',
        contact: 'Contact',
        ticket: 'Ticket',
        user: 'Agent',
        incoming: 'Incoming',
        outgoing: 'Outgoing',
        local: 'Internal',
        from: 'From',
        to: 'To',
        callDetail: 'Call detail',
        direction: 'Direction',
        duration: 'Duration',
        billDuration: 'Talk duration',
        startTime: 'Start',
        answerTime: 'Answer',
        endTime: 'End',
        hangupCause: 'End status',
        NORMAL_CLEARING: 'Successfully',
        USER_BUSY: 'Busy',
        ORIGINATOR_CANCEL: 'Caller cancel',
        NO_USER_RESPONSE: 'No answer',
        listenRecording: 'Recording',
        createContact: 'Create new contact',
        createTicket: 'Create new ticket',
        addToTicket: 'Add to existing ticket',
        content: 'Content',
        fail: 'Fail to connect',
        noTranscript: 'No transcript recorded',
        toNumber: 'To number',
        fromNumber: 'From number',
        allCallDirection: 'Call direction: All',
        allCallStatus: 'Status: All',
        audioQuality: 'Audio quality',
        na: 'Not available',
        missCall: 'Miss call',
        outboundSuccess: 'Outbound success',
        outboundFailed: 'Outbound failed',
        skip: "Skip",
        lockClient: "Are you sure this customer is violating policy?",
        deleteConfirm: "Confirm the customer is not infringing",
        lockSuccess: "Xác nhận khoá khách hàng, gửi email thông báo và thông báo đến admin",
        close: "Close",
        calls: "Calls",
        isRental: "Số cho thuê",
        isDemo: 'Số demo',
        isCommit: "Số cam kết",
        isSpam: "Số bị chặn spam",
      },
      vi: {
        faultDetectionCall: "Cuộc gọi nghi vi phạm từ khoá",
        await: "Chờ kiểm tra",
        number: 'Số',
        ext: 'Nhánh',
        contact: 'Khách',
        ticket: 'Ticket',
        user: 'Nhân viên',
        incoming: 'Gọi vào',
        outgoing: 'Gọi ra',
        local: 'Gọi nội bộ',
        from: 'Gọi từ',
        to: 'Gọi đến',
        callDetail: 'Chi tiết cuộc gọi',
        direction: 'Hướng gọi',
        duration: 'Tổng thời gian',
        billDuration: 'Đàm thoại',
        startTime: 'Bắt đầu',
        answerTime: 'Trả lời',
        endTime: 'Kết thúc',
        hangupCause: 'Kết quả',
        NORMAL_CLEARING: 'Thành công',
        USER_BUSY: 'Máy bận',
        ORIGINATOR_CANCEL: 'Người gọi dừng',
        NO_USER_RESPONSE: 'Không nghe máy',
        listenRecording: 'Nghe ghi âm',
        createContact: 'Tạo KH mới',
        createTicket: 'Tạo ticket mới',
        addToTicket: 'Thêm vào ticket',
        content: 'Nội dung',
        fail: 'Kết nối thất bại',
        noTranscript: 'Không ghi nhận được nội dung',
        toNumber: 'Gọi ra đến số',
        fromNumber: 'Gọi ra từ số',
        allCallDirection: 'Hướng gọi: Tất cả',
        allCallStatus: 'Trạng thái: Tất cả',
        audioQuality: 'Chất lượng gọi',
        na: 'Không có thông tin',
        missCall: 'Gọi nhỡ',
        outboundSuccess: 'Gọi ra thành công',
        outboundFailed: 'Gọi ra thất bại',
        skip: "Bỏ qua",
        lockClient: "Bạn chắc chắc xác định khách hàng này đang vi phạm chính sách?",
        deleteConfirm: "Xác nhận khách hàng không vi pham, bỏ qua nghi ngờ?",
        lockSuccess: "Xác nhận khoá khách hàng, gửi email thông báo và thông báo đến admin",
        close: "Đóng",
        calls: "Danh sách cuộc gọi nghi ngờ vi phạm",
        isRental: "Số cho thuê",
        isDemo: 'Số demo',
        isCommit: "Số cam kết",
        isSpam: "Số bị chặn spam",
      }
    }
  }
}
</script>